import type { Getter } from 'vuex';
import type { State as RootState } from '@/store/useStore';
import type { EmergingThreatsCommonState } from './mutations';

const emergingThreatsByID: Getter<EmergingThreatsCommonState, RootState> = (state) =>
  Object.fromEntries(state.emergingThreats.map((et) => [et.id, et]));

export const getters = {
  emergingThreatsByID,
};
